export default __webpack_public_path__ + "static/media/app-logo.3e23af1f.svg";